import React from 'react';

import { v2_parcelSearchParcelDetails } from '@lanterds/types';

import ScrollLinksNavList from 'src/components/common/ScrollLinksNavList/ScrollLinksNavList';
import ContainerHistory from '../ContainerHistory/ContainerHistory';
import ShippingLoadHistory from '../ShippingLoadHistory/ShippingLoadHistory';
import GeneratedLabelHistory from '../GeneratedLabelHistory/GeneratedLabelHistory';
import ExportInfo from '../ExportInfo/ExportInfo';
import ImportInfo from '../ImportInfo/ImportInfo';
import EventTimeline from '../EventTimeline/EventTimeline';
import ScanHistory from '../ScanHistory/ScanHistory';
import NestedContainerHistory from '../NestedContainerHistory/NestedContainerHistory';

import './MainDetailContent.scss';

interface MainDetailContentProps {
    parcel: v2_parcelSearchParcelDetails;
}

export default function MainDetailContent({ parcel }: MainDetailContentProps) {
    const links = [
        { scrollTargetId: 'scan-history', text: 'scan history' },
        { scrollTargetId: 'container-history', text: 'container' },
        { scrollTargetId: 'shipping-load-history', text: 'shipping load history' },
        { scrollTargetId: 'generated-label-history', text: 'generated label history' },
        { scrollTargetId: 'export-info', text: 'export information' },
        { scrollTargetId: 'import-info', text: 'import information' },
        { scrollTargetId: 'event-timeline', text: 'event timeline' },
    ];

    const shouldShowNestedContainerHistory = parcel?.nestedContainerHistory && parcel?.nestedContainerHistory.length > 0;

    if (shouldShowNestedContainerHistory) {
        links.splice(2, 0, { scrollTargetId: 'nested-container-history', text: 'nested container history' });
    }

    return (
        <div className="main-detail-content">
            <div className="main-detail-content__nav-container">
                <ScrollLinksNavList links={links} />
            </div>
            <div className="main-detail-content__body-container">
                <ScanHistory data={parcel?.generalParcelInfo.parcelEvents} />
                <ContainerHistory data={parcel?.containerHistory} />
                {shouldShowNestedContainerHistory && <NestedContainerHistory data={parcel.nestedContainerHistory} />}
                <ShippingLoadHistory data={parcel?.shippingLoadHistory} />
                <GeneratedLabelHistory data={parcel?.generatedLabelHistory} />
                <ExportInfo data={parcel?.exports} />
                <ImportInfo data={parcel?.imports} />
                <EventTimeline data={parcel?.timeline} />
            </div>
        </div>
    );
}
